<template>
    <div>
        <LPointClusterFeature :zIndex="30" :distance="100" :points="points" :morePointStyleFn="morePointStyleFn"
            :selectFeature="selectFeature" :key="keyVideo">
        </LPointClusterFeature>
        <el-popover placement="top" width="515" trigger="manual" v-model="visible"
            popper-class="is-no-padding is-no-arrow videoDialog_move">
            <div class="c-video-point__popover" v-if="selectVideoList.length">
                <div style="position: absolute; top: -20px; right: -20px; cursor: pointer; z-index: 99"
                    @click="visible = false">
                    <img :src="require('./../images/icon_close.png')" alt="" />
                </div>

                <div class="c-video-point__video" v-if="visible">
                    <FullScreen
                        ref="fullscreen"
                        style="width: 100%; height: 100%;"
                        @fullScreenin="isFull = true"
                        @fullScreenOut="isFull = false"
                        @dblclick.native="dblclick"
                    >
                        <CVideo v-if="selectVideo.url" :info="{}" :title="selectVideo.name" :src="selectVideo.url" />
                    </FullScreen>
                </div>
                <div class="c-video-point__videoList">
                    <YScroll style="height: 100%">
                        <template v-for="item in selectVideoList">
                            <el-tooltip :placement="(item.name).length > 11 ? 'top' : ''
                                " :content="item.name" :key="item.id + 'tip'" effect="light">
                                <div class="video-item" :class="{ active: item.id === selectVideo.id }" :key="item.id"
                                    @click="changeVideoPage(item)">
                                    {{ item.name }}
                                </div>
                            </el-tooltip>
                        </template>
                    </YScroll>
                </div>
            </div>
            <div slot="reference" :style="style"></div>
        </el-popover>
    </div>
</template>
<script>
import { YScroll, FullScreen } from '@CommonComponent';
import { OMapMixin, getStyle, LPointClusterFeature } from '@OpenLayersCommon';
import CVideo from '@/page/mainPage/components/Video.vue';

import CustomMarquee from '@/components/custom-marquee';

export default {
    mixins: [OMapMixin],
    props: {
        points: Array,
        curCamera: Object,
        keyVideo: [Number, String],
        layerAuto: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        FullScreen,
        LPointClusterFeature,
        CustomMarquee,
        CVideo,
        YScroll,
    },
    data () {
        return {
            isFull: false,
            visible: false,
            videoId: null,
            style: {
                position: 'absolute',
                top: '100px',
                left: '100px',
            },
            mapZoom: 11,
            scale: 1,
            hoverItem: null,
            styleCache: {},
            selectVideoList: [],
            videoPage: 0,
            selectVideo: {},
        };
    },
    watch: {
        mapZoom: {
            immediate: true,
            handler () {
                let scale = 1;
                let mapZoom = this.mapZoom;
                scale = (mapZoom - 13.3) * 0.2 + 0.6;
                if (scale < 0.6) scale = 0.6;
                if (scale > 1) scale = 1;
                this.scale = scale;
            },
        },
    },
    async mounted () {
        let map = await this.getMap();
        this.map = map;
        this.changeZoom();
        // 更新zoom
        this.map.getView().on('change:resolution', this.changeZoom);
    },
    methods: {
        // 弹窗拖拽事件
        move (e) {
            let odiv = document.querySelector('.videoDialog_move');
            let disX = e.clientX - odiv.offsetLeft;
            let disY = e.clientY - odiv.offsetTop;
            document.onmousemove = (event) => {
                let left = event.clientX - disX;
                let top = event.clientY - disY;
                // 移动当前元素
                odiv.style.left = `${left}px`;
                odiv.style.top = `${top}px`;
            };
            document.onmouseup = (event) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        },
        changeVideoPage (item) {
            this.selectVideo = item;
        },
        selectFeature (e, feature) {
            if (!feature) return;
            // LPointClusterFeature 传递单个feature，feature.get('features') 获取聚合后的features
            let features = feature.get('features') || [feature];
            this.selectVideoList = features.map((item) => item.values_.obj);
            this.selectVideo = this.selectVideoList[0];
            let [x, y] = e.pixel;
            this.style.top = `${y}px`;
            this.style.left = `${x}px`;
            setTimeout(() => {
                this.visible = true;
            }, 50);
        },
        changeZoom (evt) {
            const zoom = this.map.getView().getZoom(); // 获取当前地图的缩放级别
            this.mapZoom = zoom;
        },
        // 双击全屏
        dblclick () {
            this.handleFullScreen();
        },
        handleFullScreen () {
            this.$refs.fullscreen.toggleFullCreeen();
        },

        morePointStyleFn (feature) {
            let features = feature.get('features');
            let curCamera = features.find((item) => item.values_.id === this.curCamera?.id);
            const size = feature.get('features').length;
            let text;
            let style = this.styleCache[size];
            if (size === 1) {
                text = feature.get('features')[0].values_.text;
                style = getStyle({
                    icon: {
                        src:
                            this.curCamera?.id === features[0].values_.id
                                ? require('../images/icon-video-marking-active-2.png')
                                : require('../images/icon-video-marking-2.png'),
                    },
                    text: {
                        textAlign: 'center',
                        textBaseline: 'middle',
                        font: 'normal  14px  Microsoft YaHei-Regular, Microsoft YaHei',
                        text: `${text}`,
                        offsetY: 45,
                        // offsetX: 0,
                        fill: {
                            color: '#FFFFFF',
                        },
                        padding: [2, 5, 2, 5],
                        stroke: {
                            color: '#000',
                            width: 1,
                        },
                    },
                });

                this.styleCache[size] = style;
            }
            if (size > 1) {
                style = getStyle({
                    image: {
                        radius: 20,
                        stroke: {
                            color: '#49f0fd',
                            width: 2,
                        },
                        fill: {
                            color: '#1A47A499',
                        },
                    },
                    text: {
                        text: size.toString(),
                        fill: {
                            color: '#fff',
                        },
                        font: 'normal  14px  Microsoft YaHei-Regular, Microsoft YaHei',
                        offsetY: 2,
                    },
                });
                this.styleCache[size] = style;
            }
            return style;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.emergency-marking-1 {
    color: #fff;
    font-size: 12px;
    padding: 0 10px;
    line-height: 28px;
    text-align: center;
    background: rgba(7, 17, 80, 0.7);
    box-shadow: inset 0px 1px 9px 0px rgba(176, 123, 255, 0.7);
    border-radius: 15px 15px 15px 15px;
    border: 1px solid #b07bff;
}

.emergency-marking-2 {
    color: #fff;
    font-size: 12px;
    padding: 0 10px;
    line-height: 28px;
    text-align: center;
    border-radius: 15px 15px 15px 15px;
    background: rgba(7, 17, 80, 0.7);

    box-shadow: inset 0px 0px 9px 0px rgba(0, 209, 255, 0.8);
    border: 1px solid #00d1ff;
}

@include b(video-point, c) {
    @include e(popover) {
        position: relative;
        display: flex;
        width: 515px;
        height: 280px;
        text-align: center;
        padding: 4px;

        @include themify($zhongke) {
            background: #0a241c;
            border: 2px solid #1e9a74;
        }

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: -0px;
            left: 0px;
            background-color: #071150;
        }

        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 24px solid;
            box-sizing: border-box;
            border-image: url(./../images/bg_wrap.png) 24 24;
        }

        @include e(header) {
            display: inline-block;
            text-align: center;
            margin-top: 15px;
            width: 260px;
            height: 30px;
            background-color: rgba(255, 226, 184, 0.2);
            border-radius: 3px;
            outline: thick double rgba(255, 226, 184, 0.2);
            line-height: 30px;
            font-weight: 400;
            color: #ffe600;
            font-size: 16px;
        }

        @include e(video) {
            width: 350px;
            height: 100%;
            border: 1px solid #0737ff ;

            .video-title {
                overflow: hidden;
                line-height: 36px;
                text-align: left;
                padding-left: 15px;
                color: #ffe600;
                cursor: move;
            }
        }

        @include e(videoList) {
            width: calc(100% - 350px);
            height: 100%;
            margin-left: 10px;
            text-align: left;
            color: #fff;

            .video-item {
                padding: 5px;
                background: linear-gradient(90deg,
                        rgba(7, 55, 255, 0.5) 0%,
                        rgba(7, 55, 255, 0.17) 28%,
                        rgba(7, 55, 255, 0.17) 66%,
                        rgba(7, 55, 255, 0.5) 100%);
                border: 1px solid #0737ff;
                margin: 10px 10px 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;

                &:hover {
                    background: #0737ff;
                }

                &.active {
                    background: #0737ff;
                }
            }
        }
    }
}
</style>
